import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class EnumService {
  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) {}

  getAllEstadoApoio(): Observable<any> {
    return this.apiService.get(`/Enum/EstadoApoio`, this.getParams());
  }

  getAllEstadoCampanha(): Observable<any> {
    return this.apiService.get(`/Enum/EstadoCampanha`, this.getParams());
  }

  getAllEstadoPagamento(): Observable<any> {
    return this.apiService.get(`/Enum/EstadoPagamento`, this.getParams());
  }

  getAllMetodoPagamento(): Observable<any> {
    return this.apiService.get(`/Enum/MetodoPagamento`, this.getParams());
  }

  getAllNivelFinanciamento(): Observable<any> {
    return this.apiService.get(`/Enum/NivelFinanciamento`, this.getParams());
  }

  getAllTipoFinanciamento(): Observable<any> {
    return this.apiService.get(`/Enum/TipoFinanciamento`, this.getParams());
  }

  getAllTipoRecompensa(): Observable<any> {
    return this.apiService.get(`/Enum/TipoRecompensa`, this.getParams());
  }

  getAllAtivitysLog(): Observable<any> {
    return this.apiService.get(`/Enum/AtivityLogs`, this.getParams());
  }

  getAllEntidade(): Observable<any> {
    return this.apiService.get(`/Enum/Entidade`, this.getParams());
  }

  getAllTipoDocumento(): Observable<any> {
    return this.apiService.get(`/Enum/TipoDocumento`, this.getParams());
  }

  getAllConfiguracoes(): Observable<any> {
    return this.apiService.get(`/Enum/Configuracoes`, this.getParams());
  }

  getAllAprovacaoCampanha(): Observable<any> {
    return this.apiService.get(`/Enum/AprovacaoCampanha`, this.getParams());
  }

  getAllFrequencia(): Observable<any> {
    return this.apiService.get(`/Enum/Frequencia`, this.getParams());
  }

  getAllMotivoSuspensao(): Observable<any> {
    return this.apiService.get(
      `/Enum/MotivoAvaliacaoCampanha`,
      this.getParams(),
    );
  }

  getAllGestaoPaginaTipoDado(): Observable<any> {
    return this.apiService.get(`/Enum/GestaoPaginaTipoDado`, this.getParams());
  }

  getAllGestaoPagina(): Observable<any> {
    return this.apiService.get(`/Enum/GestaoPagina`, this.getParams());
  }

  getTipofinanciamentoValid(params?: any): Observable<any> {
    const httpParams = params
      ? new HttpParams({ fromObject: params })
      : this.params;
    return this.apiService.get(`/Configuracoes/Dominio`, httpParams).pipe(
      catchError(() =>
        this.apiService.get(`/Dominio/CampanhaConfiguracao`, httpParams),
      ),
      map((response) => response),
    );
  }

  private getParams(params?: any): HttpParams {
    return params ? new HttpParams({ fromObject: params }) : new HttpParams();
  }
}
